











import {Component, Provide, Vue, Prop, Watch} from 'vue-property-decorator';
import {computed} from 'types/vue-toast-notification';
/*FormInput component for project
  prop: title = title of button
  prop: onEnterPress = onEnterClickHandler
  prop: error = for showing error msgs
  prop: validatorFn = accepting validation fn
*/
@Component
export default class FormInput extends Vue {
  @Prop() title: string;
  @Prop() onEnterPress: any;
  @Prop() error: string;
  @Prop() validatorFn: any;
  @Prop() mandatory: boolean;
  @Prop() value: any;
  @Prop() inputType: string;
  @Prop() onValueChange: any;

  formTitle = null;
  errorMsg = null;
  validateField = null;
  isRequired = true;
  type = 'text';
  inputValue = null;

  @Watch('title', {immediate: true})
  titleChanged(newValue: string, oldValue: string) {
    if (newValue) this.formTitle = newValue;
  }
  @Watch('value', {immediate: true})
  valueChanged(newValue: any, oldValue: any) {
    this.inputValue = newValue;
  }
  @Watch('error', {immediate: true})
  errorChanged(newValue: string, oldValue: string) {
    this.errorMsg = newValue;
  }
  @Watch('inputType', {immediate: true})
  inputTypeChanged(newValue: string, oldValue: string) {
    if (newValue) this.type = newValue;
  }
  @Watch('mandatory', {immediate: true})
  mandatoryChanged(newValue: boolean, oldValue: boolean) {
    this.isRequired = newValue;
    if (this.isRequired == null) this.isRequired = true;
  }

  @Watch('inputValue')
  valueUpdated(newValue: any, oldValue: any) {
    if (this.onValueChange) this.onValueChange(newValue);
  }

  onHitEnter() {
    if (this.onEnterPress) this.onEnterPress();
  }

  onFocusAndKeyUp() {
    if (this.validatorFn) this.validatorFn();
  }
}
